<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="sysconfiginfo" :rules="rules" ref="sysconfigrule" label-width="120px" class="">
			<el-row>
				<el-col :span="10">
					<el-form-item label="配置名称" prop="name">
						<el-input clearable v-model="sysconfiginfo.name" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
					<el-form-item label="配置编码" prop="code">
						<el-input clearable v-model="sysconfiginfo.code" :disabled="disabled_cord" maxlength="30"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="20">
					<el-form-item v-if="sysconfiginfo.code == 'OpFaultAndOffline' || sysconfiginfo.code == 'SchoolOutShow'" label="配置参数" prop="value">
						<el-select style="width: 100%;" multiple v-model="orgids" placeholder="请选择校区">
							<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-else label="配置参数" prop="value">
						<el-input type="textarea" :rows="8" placeholder="请输入配置参数" maxlength="99999" clearable v-model="sysconfiginfo.value"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveSysConfigs">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { addSysConfig,eidtSysConfig, queryAllOrg } from '/static/apiUrl.js'
	export default {
		name : 'SysConfigDetail',
		data() {
			return {
				orgList : [],
				orgids : [],
				editok: false,
				disabled_cord: false,
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},				
				sysconfiginfo : {
					id: "",
					name: "",
					code: "",
					value: "",
				},			
				rules:{
					name: [
						{ required: true, message: '请输入配置名称', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入配置编码', trigger: 'blur' }
					],
					value: [
						{ required: true, message: '请输入配置值', trigger: 'blur' }
					],
				}
			}
		},
		mounted() {
			this.initData()
		},
		BeforeCreate(){
			
		},
		props: {
			selectconfig : {
				type: Object,
				required: false
			}
		},
		watch: {
			selectconfig: {
				immediate: true,
				handler(newVal) {	
					this.orgids = []		
					this.clearData()
					if (newVal != null && newVal != "") {						
						this.disabled_cord = true
						this.sysconfiginfo.id = newVal.id
						this.sysconfiginfo.name = newVal.name
						this.sysconfiginfo.code = newVal.code
						this.sysconfiginfo.value = newVal.value
						if(this.sysconfiginfo.code == 'OpFaultAndOffline' || this.sysconfiginfo.code == 'SchoolOutShow'){
							this.orgids = JSON.parse(newVal.value)
						}
					}else{
						this.sysconfiginfo.id = ''
						this.sysconfiginfo.name = ''
						this.sysconfiginfo.code = ''
						this.sysconfiginfo.value = ''
						this.disabled_cord = false
					}
				}
			},
		},
		methods: {
			clearData(){
				this.editok = false
				this.disabled_cord = false
			},
			initData() {
				this.orgList = []
				queryAllOrg().then(res => {
					if(0 == res.code){
						res.datas.forEach((org) => {
							if("XQ" == org.type){
								this.orgList.push(org)
							}
						})
					}
				})
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			saveSysConfigs(){
				this.$refs["sysconfigrule"].validate((valid) => {
					if (valid) {
						if(this.sysconfiginfo.code == 'OpFaultAndOffline' || this.sysconfiginfo.code == 'SchoolOutShow'){
							this.sysconfiginfo.value = JSON.stringify(this.orgids)
						}
						if(this.sysconfiginfo.id != null && this.sysconfiginfo.id != ''){  //编辑
							eidtSysConfig(this.sysconfiginfo).then(res => {
								//console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改配置信息成功")
								}else{
									this.$message.error(res.messge,true)
								}
							})
						}else{ //新增
							addSysConfig(this.sysconfiginfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加配置信息成功")
								}else{
									this.$message.error(res.messge)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>